import { useCallback, useEffect, useRef } from 'react';

export default function usePreservedCallback<
  Callback extends (...args: Parameters<Callback>) => ReturnType<Callback>,
>(callback: Callback) {
  const callbackRef = useRef<Callback>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useCallback((...args: Parameters<Callback>) => {
    return callbackRef.current(...args);
  }, []) as Callback;
}
